import { api, publicApi } from '@/services/api';
import type { ApiResponse } from '@/types/api';
import type { ProfessionalProfile, PublicProfessionalProfile } from '@/types/marketplace';

export interface UpsertProfessionalProfileInput {
  businessName: string;
  bio?: string;
  district?: string;
  city?: string;
  freguesia?: string;
  categoryIds: number[];
  referralCodeUsed?: string;
}

export const professionalProfileService = {
  getMine: async () => {
    const response = await api.get<ApiResponse<ProfessionalProfile | null>>(
      '/marketplace/professional/profile',
    );
    return response.data.data;
  },

  upsertMine: async (payload: UpsertProfessionalProfileInput) => {
    const response = await api.put<ApiResponse<ProfessionalProfile>>(
      '/marketplace/professional/profile',
      payload,
    );
    return response.data.data;
  },

  getPublicById: async (id: number) => {
    const response = await publicApi.get<ApiResponse<PublicProfessionalProfile>>(
      `/marketplace/public/professionals/${id}`,
    );
    return response.data.data;
  },
};
